/**
 * Получаем ширину скроллбара
 * и записываем в css-переменную
 */

 class ScrollbarWidthChecker {
    constructor() {
        this.getCurrentWidth();
        this.bindEvents();
    }


    getCurrentWidth() {
        /**
         * Получаем ширину скролбара всего окна в НАСТОЯЩИЙ МОМЕНТ.
         * Если скроллбара нет, то будет == 0, что не говорит о ширине
         * скроллбара в целом
         */
        const w = window.innerWidth - document.documentElement.clientWidth;
        document.documentElement.style.setProperty('--currentScrollbarWidth', w + 'px');
    }


    bindEvents() {
        App.W.on('resized', () => {
            this.getCurrentWidth();
        });
    }
}

new ScrollbarWidthChecker();



// WEBPACK FOOTER //
// ./_src/js/modules/ScrollbarWidthChecker.js